import { render, staticRenderFns } from "./PolicyDetail.vue?vue&type=template&id=2d729726"
import script from "./PolicyDetail.vue?vue&type=script&lang=js"
export * from "./PolicyDetail.vue?vue&type=script&lang=js"
import style0 from "./PolicyDetail.vue?vue&type=style&index=0&id=2d729726&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports